module.exports = __webpack_public_path__ + "static/retail_ecommerce-6dbc9253024f97cddce446a0c070bc22.png";